import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import styled from 'styled-components';
import styles from './Pagination.style';
import List from '../../molecules/List';
import Anchor from '../../atoms/Anchor';
import ListItem from '../../molecules/List/ListItem';
import { getPath } from '../../../../internal/utils/router';
var Pagination = /*#__PURE__*/function (_Component) {
  _inherits(Pagination, _Component);
  var _super = _createSuper(Pagination);
  function Pagination(props) {
    var _this;
    _classCallCheck(this, Pagination);
    _this = _super.call(this, props);
    _this.getPages = _this.getPages.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Pagination, [{
    key: "paginationUrl",
    value: function paginationUrl(seq) {
      var _this$props = this.props,
        omitSeq = _this$props.omitSeq,
        fallbackUrl = _this$props.fallbackUrl,
        pageRoute = _this$props.pageRoute;
      // Use array of segments for routing
      if (pageRoute) {
        var route = omitSeq ? pageRoute : pageRoute.concat([seq]);
        return getPath(route);
      }
      // Use legacy fallbackUrl method of generating links
      return omitSeq ? "".concat(fallbackUrl) : "".concat(fallbackUrl).concat(seq);
    }
  }, {
    key: "getPages",
    value: function getPages(fallbackUrl) {
      var list = [];
      var _this$props2 = this.props,
        totalPages = _this$props2.totalPages,
        currentPage = _this$props2.currentPage,
        handleClickEvent = _this$props2.handleClickEvent,
        pageRoute = _this$props2.pageRoute;
      if (currentPage < 1) {
        currentPage = 1;
      } else if (currentPage > totalPages) {
        currentPage = totalPages;
      }
      for (var seq = 1; seq <= totalPages; seq++) {
        if (seq === 1 && !(seq === currentPage)) {
          list.push(__jsx(ListItem, {
            className: "nva-pagination__page page ".concat(currentPage === seq ? 'is-active active' : ''),
            key: seq
          }, __jsx(Anchor, {
            title: seq,
            to: "/".concat(pageRoute),
            handleLinkClick: handleClickEvent,
            forceClick: true
          }, seq)));
        }
        if (seq === totalPages && !(seq === currentPage)) {
          list.push(__jsx(ListItem, {
            className: "nva-pagination__page page ".concat(currentPage === seq ? 'is-active active' : ''),
            key: seq
          }, __jsx(Anchor, {
            title: seq,
            to: this.paginationUrl(seq),
            handleLinkClick: handleClickEvent,
            forceClick: true
          }, seq)));
        }
        if (seq === currentPage) {
          list.push(__jsx(ListItem, {
            className: "nva-pagination__page is-active page active",
            key: seq
          }, __jsx(Anchor, {
            title: seq,
            to: seq === 1 ? "/".concat(pageRoute) : this.paginationUrl(seq),
            handleLinkClick: handleClickEvent,
            forceClick: true
          }, seq)));
        }
        if (seq !== 1 && seq !== totalPages && seq === currentPage + 1) {
          list.push(__jsx(ListItem, {
            className: "nva-pagination__page page",
            key: seq
          }, __jsx(Anchor, {
            title: seq,
            to: this.paginationUrl(seq),
            handleLinkClick: handleClickEvent,
            forceClick: true
          }, seq)));
        }
        if (seq !== 1 && seq !== totalPages && seq === currentPage - 1) {
          list.push(__jsx(ListItem, {
            className: "nva-pagination__page page",
            key: seq
          }, __jsx(Anchor, {
            title: seq,
            to: this.paginationUrl(seq),
            handleLinkClick: handleClickEvent,
            forceClick: true
          }, seq)));
        }
        if (seq !== 1 && seq !== totalPages && seq === currentPage + 2) {
          list.push(__jsx(ListItem, {
            className: "nva-pagination__dots dots",
            key: seq
          }, "..."));
        }
        if (seq !== 1 && seq !== totalPages && seq === currentPage - 2) {
          list.push(__jsx(ListItem, {
            className: "nva-pagination__dots dots",
            key: seq
          }, "..."));
        }
      }
      return list;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        className = _this$props3.className,
        totalPages = _this$props3.totalPages,
        currentPage = _this$props3.currentPage,
        fallbackUrl = _this$props3.fallbackUrl,
        handleClickEvent = _this$props3.handleClickEvent,
        pageRoute = _this$props3.pageRoute;
      return __jsx("div", {
        className: className
      }, totalPages !== 0 && totalPages !== 1 && __jsx(List, {
        className: "nva-pagination pagination"
      }, __jsx(ListItem, {
        className: "prev-arrow-container"
      }, __jsx(Anchor, {
        title: "prev-arrow ".concat(currentPage <= 1 ? 'disabled' : ''),
        to: currentPage === 2 ? "/".concat(pageRoute) : this.paginationUrl(currentPage - 1),
        className: "nva-pagination__prev-arrow prev-arrow ".concat(currentPage <= 1 ? 'disabled' : ''),
        handleLinkClick: handleClickEvent,
        forceClick: true,
        disabled: currentPage <= 1 ? 'disabled' : false
      })), this.getPages(fallbackUrl), __jsx(ListItem, {
        className: "next-arrow-container"
      }, __jsx(Anchor, {
        title: "next-arrow ".concat(currentPage >= totalPages ? 'disabled' : ''),
        to: this.paginationUrl(currentPage + 1),
        className: "nva-pagination__next-arrow next-arrow ".concat(currentPage >= totalPages ? 'disabled' : ''),
        forceClick: true,
        handleLinkClick: handleClickEvent,
        disabled: currentPage >= totalPages ? 'disabled' : false
      }))));
    }
  }]);
  return Pagination;
}(Component);
_defineProperty(Pagination, "defaultProps", {
  className: '',
  omitSeq: false
});
export default styled(Pagination).withConfig({
  componentId: "sc-q3nbfl-0"
})(["", ";"], styles);
export { Pagination as PaginationVanilla };